export const RadioValues = {
  Opcion1: 1,
  Opcion2: 2,
};

export const RadioLabels = {
  [RadioValues.Opcion1]: "Excepción",
  [RadioValues.Opcion2]: "Habilitación",
};